<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'BUYERS.RESIDENCY_LABEL' | translate }}</h3>
    </div>
  </div>
  <div class="sp-width__full sp-margin__top sp-buyer-details-general-residency__grid sp-grid__column-gap-x2">
    <app-shared-info
      [label]="'BUYERS.COUNTRY_LABEL'"
      [content]="buyer?.residency?.country || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.CITY_LABEL'"
      [content]="buyer?.residency?.city || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.ADDRESS_LABEL'"
      [content]="buyer?.residency?.address || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.HOUSE_NUMBER_LABEL'"
      [content]="buyer?.residency?.house_number || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.PROVINCE_LABEL'"
      [content]="buyer?.residency?.province || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.ZIP_CODE_LABEL'"
      [content]="buyer?.residency?.zip_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'BUYERS.DOMICILE_LABEL' | translate }}</h3>
    </div>
  </div>
  <div class="sp-width__full sp-margin__top sp-buyer-details-general-residency__grid sp-grid__column-gap-x2">
    <app-shared-info
      [label]="'BUYERS.COUNTRY_LABEL'"
      [content]="buyer?.domicile?.country || buyer?.residency?.country || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.CITY_LABEL'"
      [content]="buyer?.domicile?.city || buyer?.residency?.city || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.ADDRESS_LABEL'"
      [content]="buyer?.domicile?.address || buyer?.residency?.address || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.HOUSE_NUMBER_LABEL'"
      [content]="buyer?.domicile?.house_number || buyer?.residency?.house_number || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.PROVINCE_LABEL'"
      [content]="buyer?.domicile?.province || buyer?.residency?.province || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'BUYERS.ZIP_CODE_LABEL'"
      [content]="buyer?.domicile?.zip_code || buyer?.residency?.zip_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
